import { FC } from "react";
import styles from "./buttonProduct.module.css";
import { QuantityButton } from "../QuantityButton";
import { BasketIcon } from "../MenuIcons/Basket";
import IconesNovos from "../NewIcones/IconesNovos";
import React from "react";

const ButtonProduct: FC<{
  action: any;
  label: string;
  backgroundColor: string;
  color: string;
  marginBottom?: boolean;
  price: number;
  promotionalPrice?: number;
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  inputChange?: (value: number) => void;
}> = ({
  label,
  action,
  color,
  backgroundColor,
  marginBottom,
  price,
  promotionalPrice = 0,
  quantity,
  onIncrease,
  onDecrease,
  inputChange,
}) => {
  // Função para formatar o preço
  const floatToPrice = (value: number) =>
    value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  // Função para calcular o desconto percentual
  const getDiscountPercent = (price: number, promotionalPrice: number) => {
    if (!price || !promotionalPrice || promotionalPrice >= price) return null;
    const percent = Math.round(((price - promotionalPrice) / price) * 100);
    return `-${percent}%`;
  };

  return (
    <div
      className={styles.button}
      style={marginBottom ? { bottom: "5em" } : { bottom: "0em" }}
    >
      <div
        className={styles["bp-quantity-product"]}
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        {promotionalPrice !== 0 && promotionalPrice !== price ? (
          <>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span
                style={{
                  textDecoration: "line-through",
                  color: "#999",
                  fontSize: 13,
                }}
              >
                {floatToPrice(price * quantity)}
              </span>
              <span
                style={{
                  background: "#FFD600",
                  color: "#222",
                  fontWeight: 700,
                  fontSize: 12,
                  borderRadius: 4,
                  padding: "2px 4px",
                  marginLeft: 2,
                }}
              >
                {getDiscountPercent(price, promotionalPrice)}
              </span>
            </span>
            <span
              style={{
                color: "#111",
                fontWeight: 800,
                fontSize: 22,
                display: "block",
              }}
            >
              {floatToPrice(promotionalPrice * quantity)}
            </span>
          </>
        ) : (
          <span
            style={{
              color: "#111",
              fontWeight: 800,
              fontSize: 22,
              display: "block",
            }}
          >
            {floatToPrice(price * quantity)}
          </span>
        )}
      </div>
      <button
        onClick={() => action && action()}
        style={{
          backgroundColor: backgroundColor,
          color: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          minWidth: 120,
          fontSize: 16,
          fontWeight: 600,
          flex: 1,
        }}
      >
        <IconesNovos
          cor={color}
          active={true}
          type="cart_small"
          action={() => {}}
        />
        {label}
      </button>
    </div>
  );
};

export { ButtonProduct };
